import React from 'react'
import PropTypes from "prop-types"
import { RichText } from 'prismic-reactjs'
import { ThemeProvider } from "styled-components"

import { getTheme } from '../../theme/theme'

import Blocks from '../blocks'
import Quote from '../quote'
import TextAndImage from '../text-and-image'
import Points from '../points'
import Promo from '../promo'
import Action from '../action'
import Steps from '../steps'
import Questions from '../questions'
import Story from '../story'
import Team from '../team'
import PromoteBlog from '../promote-blog'
import Form from '../form'
import Table from '../table'

import { Container } from './complex-body.styles'


const ComplexBody = ({heading,body,overlap=false,overlapSmall=false}) => {
	let o = overlap;
	let os = overlapSmall;
	let component;
	let count = {};

	if(body && body.length > 0){
		return (
			<Container>
				{
					body.map((item, index) => {
						count[item.type] = count[item.type] + 1 || 0;
						switch(item.type){
							case 'blocks': 
							component = <Blocks key={index} {...item.primary} items={item.fields} overlap={o} overlapSmall={os} count={count[item.type]} />;
							o = false;
							os = false;
							return component;

							case 'quote': 
							component = <Quote key={index} {...item.primary} overlap={o} overlapSmall={os} count={count[item.type]} />;
							o = true;
							os = true;
							return component;

							case 'text_and_image': 
							component = <TextAndImage key={index} {...item.primary} items={item.fields} overlap={o} overlapSmall={os} count={count[item.type]} />;
							o = false;
							os = false;
							return component;

							case 'points': 
							component = <Points key={index} {...item.primary} items={item.fields} overlap={o} overlapSmall={os} count={count[item.type]} />;
							o = false;
							os = false;
							return component;

							case 'promo': 
							component = <Promo key={index} {...item.primary} overlap={o} overlapSmall={os} count={count[item.type]} />;
							o = false;
							os = false;
							return component;

							case 'action': 
							component = <Action key={index} {...item.primary} overlap={o} overlapSmall={os} count={count[item.type]} />;
							o = false;
							os = false;
							return component;

							case 'steps': 
							component = <Steps key={index} {...item.primary} items={item.fields} overlap={o} overlapSmall={os} count={count[item.type]} />;
							o = false;
							os = false;
							return component;

							case 'questions': 
							component = <Questions key={index} {...item.primary} items={item.fields} overlap={o} overlapSmall={os} count={count[item.type]} />;
							o = false;
							os = false;
							return component;

							case 'story': 
							component = <Story key={index} {...item.primary} items={item.fields} overlap={o} overlapSmall={os} count={count[item.type]} />;
							o = false;
							os = false;
							return component;

							case 'team': 
							component = <Team key={index} {...item.primary} items={item.fields} overlap={o} overlapSmall={os} count={count[item.type]} />;
							o = false;
							os = false;
							return component;

							case 'promote_blog': 
							component = <PromoteBlog key={index} {...item.primary} items={item.fields} overlap={o} overlapSmall={os} count={count[item.type]} />;
							o = false;
							os = false;
							return component;

							case 'form': 
							component = <Form key={index} {...item.primary} items={item.fields} overlap={o} overlapSmall={os} count={count[item.type]} />;
							o = false;
							os = false;
							return component;

							case 'table': 
							component = <Table key={index} {...item.primary} items={item.fields} overlap={o} overlapSmall={os} count={count[item.type]} />;
							o = false;
							os = false;
							return component;
						}
						return null;
					})
				}
			</Container>
		)
	}

	return null;
}

export default ComplexBody;